/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {getHomepage} from "../../../../../selectors/my-puratos/generics";
import {connect} from "react-redux";
import {DesktopOnly, MobileOnly, Table, useIsMobile} from "../../../atoms/table/Table";
import {CELL_SIZE, ProductDescriptionCell, ProductImageCell, QuantityInputCell,} from "../../../atoms/table/Cells";
import {EMPTY_OBJECT} from "../../../../../utils/my-puratos";
import {renderPackagePrice} from "./ProductRow";
import {RoleMatrix} from "../../../../../utils/my-puratos/roleUtils";
import {WithRole} from "../../../hoc/withRole";


function RelatedProductRow(props) {
    const {data: product, i18n, homepage, homePageModel, showPrice} = props;
    const isMobile = useIsMobile();
    return (
        <Table.Row className={'p-bgcolor-faded-yellow related'}>
            <ProductImageCell valign={"center"} align={"center"} size={CELL_SIZE._100} product={product}
                              fallbackImage={homepage.fallbackImage} showCartAmount/>
            <ProductDescriptionCell size={CELL_SIZE._equalLg} i18n={i18n} product={product}/>
            <MobileOnly>
                <WithRole roles={[RoleMatrix.puratosCustomerValidated]}>
                    <QuantityInputCell valign={"center"} align={"right"} size={CELL_SIZE._125} mr={isMobile ? 0 : 75}
                                       disableInput modifiable={false} product={product}/>
                </WithRole>
            </MobileOnly>
            {renderPackagePrice(product, homePageModel, i18n, false, true, showPrice)}
            <DesktopOnly>
                <WithRole roles={[RoleMatrix.puratosCustomerValidated]}>
                    <QuantityInputCell valign={"center"} align={"center"} size={CELL_SIZE._125} mr={isMobile ? 0 : 75}
                                       disableInput modifiable={false} product={product}/>
                </WithRole>
            </DesktopOnly>
        </Table.Row>
    );
}

const mapStateToProps = (state) => ({
    homePageModel: state.myPuratos_aem.homepage || EMPTY_OBJECT,
    homepage: getHomepage(state)
});

export default connect(mapStateToProps, null)(RelatedProductRow);
